/* RocketFuel: shared country detection (window.rfGetCountry), used by the
   shipping, delivered price, volume tier and header blocks. */
(function () {
if (!window.rfGetCountry) {
        window.rfGetCountry = (function () {
          var promise = null;
          function readSession(key) { try { return sessionStorage.getItem(key); } catch (e) { return null; } }
          function writeSession(key, value) { try { sessionStorage.setItem(key, value); } catch (e) {} }
          function readCookie(name) {
            try {
              var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
              return match ? decodeURIComponent(match[1]) : null;
            } catch (e) { return null; }
          }
          function isPreview(designMode) {
            if (designMode === 'true') return true;
            if (window.Shopify && window.Shopify.designMode) return true;
            var theme = window.Shopify && window.Shopify.theme;
            if (theme && theme.role && theme.role !== 'main') return true;
            return /[?&]preview_theme_id=/.test(window.location.search);
          }
          function rememberSelectorChoice(event) {
            var target = event.target;
            if (!target || !target.closest) return;
            var form = target.closest('form[action*="/localization"], localization-form, [data-localization-form]');
            if (!form) return;
            setTimeout(function () {
              var input = form.querySelector('[name="country_code"]');
              var value = (input && input.value) || (target.dataset && (target.dataset.value || target.dataset.countryCode)) || target.value || '';
              value = String(value).toUpperCase();
              if (/^[A-Z]{2}$/.test(value)) writeSession('rfChosenCountry', value);
            }, 0);
          }
          document.addEventListener('click', rememberSelectorChoice, true);
          document.addEventListener('change', rememberSelectorChoice, true);
          document.addEventListener('submit', rememberSelectorChoice, true);

          return function (liquidCountry, designMode) {
            if (promise) return promise;
            liquidCountry = String(liquidCountry || '').toUpperCase();
            if (!/^[A-Z]{2}$/.test(liquidCountry)) liquidCountry = '';
            var lastLiquid = readSession('rfLastLiquidCountry');
            if (liquidCountry) writeSession('rfLastLiquidCountry', liquidCountry);
            if (liquidCountry && isPreview(designMode)) return (promise = Promise.resolve(liquidCountry));
            var cookieCountry = String(readCookie('localization') || '').toUpperCase();
            if (/^[A-Z]{2}$/.test(cookieCountry)) return (promise = Promise.resolve(liquidCountry || cookieCountry));
            var chosen = String(readSession('rfChosenCountry') || '').toUpperCase();
            if (/^[A-Z]{2}$/.test(chosen)) return (promise = Promise.resolve(liquidCountry || chosen));
            if (liquidCountry && lastLiquid && lastLiquid !== liquidCountry) {
              writeSession('rfChosenCountry', liquidCountry);
              return (promise = Promise.resolve(liquidCountry));
            }
            var cached = readSession('rfDetectedCountry');
            var lookup = cached !== null
              ? Promise.resolve(cached === 'none' ? null : cached)
              : fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
                  .then(function (res) { return res.ok ? res.json() : null; })
                  .then(function (data) {
                    var handle = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
                    var code = handle ? String(handle).toUpperCase() : null;
                    writeSession('rfDetectedCountry', code || 'none');
                    return code;
                  })
                  .catch(function () { return null; });
            promise = lookup
              .then(function (detected) { return detected || liquidCountry || null; })
              .catch(function () { return liquidCountry || null; });
            return promise;
          };
        })();
      }
})();
